<template>
  <div>
    <div class="banner99">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082711490799.jpg"></el-image>
      <div class="cover">
        <h1>业务概况</h1>
        <div class="subtitle">健康手套</div>
      </div>
    </div>
    <div class="content">
      <div class="box1">
        <div class="title">我们的愿景是为全球带来 ˹美好生活触手可及˼</div>
        <div class="subtitle">在诗董手套，我们的首要任务是守护手部健康，保护医疗和其他行业的每一位用户。从原材料的核心到内部创新和尖端技术的开发，我们的研究正持续不断地进行。</div>
      </div>
      <div class="world">
        <video autoplay="autoplay" loop="loop" muted="muted" style="width: 50%; height: 100%;">
          <source data-v-76464aa9="" src="https://sritrang.oss-cn-shanghai.aliyuncs.com/video/vision-world.mp4"
                  type="video/mp4">
          您的浏览器不支持视频播放，请更新到最新版本
        </video>
      </div>
      <div class="box1">
        <div class="title">诗董手套（泰国）公共有限公司</div>
        <div class="subtitle">
          我们的一生，每一次触摸都有其意义。从我们降临到这个世界的第一天起，一副手套将我们带至母亲的怀抱。当您穿越生命的每个阶段，手套给予您悉心的保护。在医疗和制造业的各个领域，手套已成为我们生活中不可或缺的一部分。
        </div>
      </div>
      <el-image style="width: 100%" mode="cover" src="/img/ywgk_1.png"></el-image>
      <el-image style="width: 100%" mode="cover" src="/img/ywgk_2.png"></el-image>
      <div class="img3">
        <el-row>
          <el-col :span="8"></el-col>
          <el-col :span="16"></el-col>
        </el-row>
        <el-row>
          <el-col :span="8"></el-col>
          <el-col :span="16"></el-col>
        </el-row>
      </div>
      <div class="img4">
        <el-row>
          <el-col :span="8"></el-col>
          <el-col :span="16"></el-col>
        </el-row>
      </div>
    </div>
    <div class="img5">
      <el-row>
        <el-col :span="10">
          <div class="b-left">
            <div class="t1">领先科技</div>
            <div class="t2">尖端技术和持续创新</div>
            <div class="t3">
              凭借多年的经验，诗董手套成为设计和制造领先手套的专家。我们采用高度灵活和高效的生产工艺，实施快速、卫生和自动化的生产过程，以严格的质量控制确保高质量的手部防护产品满足全球范围内各类客户的需求。
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="b-right">

          </div>
        </el-col>
      </el-row>
    </div>
    <div class="img6">
      <el-row>
        <el-col :span="14">
          <div class="b-img"></div>
        </el-col>
        <el-col :span="10">
          <div class="b-left">
            <div class="t1">优质原料</div>
            <div class="t2">不仅是手套制造商，更是“全产业集成橡胶公司”的一部分</div>
            <div class="t3">
              我们将原材料作为研发核心，我们相信伟大的产品始于优质的原材料。诗董手套利用集团自有乳胶原材料优势，融合了对天然乳胶和丁腈橡胶的专业知识。同时对原料氨、天然乳胶中的蛋白质含量、凝固剂和许多其他成分的每个细节也保持高度关注。
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="img7">
      <el-row>
        <el-col :span="10">
          <div class="bb-box">
            <div class="b1">可持续发展</div>
            <div class="b2">我们的愿景是为全球带来 ˹美好生活触手可及˼</div>
            <div class="b3">
              我们致力于以透明和公平的方式开展业务，生产高品质和环保型产品，实现 ˹美好生活触手可及˼ 的目标，我们也关注供应链中从上游到下游的各类利益相关者。这不只是为了用户，也为了守护美丽世界的每一个生命。
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="bb-tv">
            <div class="vd">
              <video loop="loop" poster="/img/master.jpg" muted="muted" controls="controls"
                     style="width: 100%; height: 100%;">
                <source src="https://sritrang.oss-cn-shanghai.aliyuncs.com/video/02%20Master%20STGT%20Corporate%20%5BENG&CHS%5D(V4).mp4"
                        type="video/mp4">
                您的浏览器不支持视频播放，请更新到最新版本
              </video>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>
@import url("Index.css");
</style>
